export const ENDPOINTS = {
  getSuccessData: {
    path: '/get-success-data'
  },
  getProductTypeDetails: {
    path: '/get-product-type'
  }
};
//# sourceMappingURL=endpoints.js.map